export default __webpack_public_path__ + "static/heroImgBg-d655e7f65d6863efc63914beef10ce57.png";